module.exports = __webpack_public_path__ + "img/ua.8f5e3fd1.png";